import React from "react"
import ReactDOM from 'react-dom/client';
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import {Router} from "react-router-dom"
import history from './history';
import "./i18n"

import {Provider} from "react-redux"

import store from "./store"

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={store}>
        <Router history={history}>
            <App/>
        </Router>
    </Provider>
);
serviceWorker.unregister()
